import type { CSSProperties, ReactElement } from 'react';

/**
 * Google Material Symbols glyph. The font is loaded in index.html; icons are referenced by name
 * (https://fonts.google.com/icons) as ligatures, so there are no custom SVG paths anywhere in the
 * chrome. `size` sets the optical size in px (defaults to the surrounding font-size).
 */
export function MaterialIcon({
  name,
  size,
  className,
  style: styleProp,
}: {
  name: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
}): ReactElement {
  const style: CSSProperties | undefined = size || styleProp ? { ...(size ? { fontSize: size } : {}), ...styleProp } : undefined;
  return (
    <span className={`material-symbols-outlined${className ? ` ${className}` : ''}`} style={style} aria-hidden="true">
      {name}
    </span>
  );
}
